import {
  CheckIcon,
  GKButton,
  GKEditor,
  GKModal,
  GKTextField,
  Grid2,
} from "components";
import { FeePlansForm } from "interfaces/Revenue";
import { Controller, useFormContext } from "react-hook-form";
import { useParams } from "react-router-dom";
import { useUpdateFeePlanMutation } from "store/features/Revenue/FeePlan";
import { GKModalProps } from "utils/commonInterface";

const FeePlanDetailsModal = (props: GKModalProps) => {
  const { open, setOpen } = props;
  const { id } = useParams();

  const form = useFormContext<FeePlansForm>();
  const [updateFeePlan, { isLoading }] = useUpdateFeePlanMutation();

  const onSubmit = form.handleSubmit(async (values) => {
    await updateFeePlan({
      id,
      body: {
        name: values.name,
        description: values.description,
      },
    });
    setOpen(false);
  });

  return (
    <GKModal
      open={open}
      setOpen={setOpen}
      modalTitle={"Edit Fee Plan"}
      width={"570px"}
      footer={
        <Grid2
          container
          size={12}
          display={"flex"}
          justifyContent={"space-between"}
        >
          <GKButton
            variant="outlined"
            color="dark"
            onClick={() => setOpen(false)}
          >
            Cancel
          </GKButton>
          <GKButton
            variant="contained"
            loading={isLoading}
            startIcon={<CheckIcon />}
            type="submit"
            form="fee-plan-update-form"
          >
            Save Changes
          </GKButton>
        </Grid2>
      }
    >
      <form id="fee-plan-update-form" onSubmit={onSubmit}>
        <Grid2 container spacing={3}>
          <Grid2 size={12}>
            <Controller
              name="name"
              control={form.control}
              render={({ field }) => (
                <GKTextField
                  {...field}
                  inputLabel="Fee Plan Name"
                  name="name"
                />
              )}
            />
          </Grid2>
          <Grid2 size={12}>
            <Controller
              name="description"
              control={form.control}
              render={({ field }) => (
                <GKEditor
                  value={field.value}
                  onChange={field.onChange}
                  inputLabel="Description"
                  charLimit={150}
                  toolbar={[
                    "undo",
                    "redo",
                    "|",
                    "heading",
                    "bold",
                    "italic",
                    "underline",
                    "strikethrough",
                    "blockQuote",
                    "|",
                    "fontSize",
                    "fontColor",
                    "fontBackgroundColor",
                    "|",
                  ]}
                />
              )}
            />
          </Grid2>
        </Grid2>
      </form>
    </GKModal>
  );
};

export default FeePlanDetailsModal;
